import { IS_CLIENT } from "@/common/api";
import { SOFT } from "@/common/url";
import { OpenType } from "@q/softCore";
import React, { useEffect, useRef } from "react";
import { IAds } from "@/common/interface";
import { sendClkLog } from "@/common/selfMonitor";
import { getOpenHandler, getFullUrl } from "@/utils/appInstall";
import { comMonitor, replaceUrlTemplate, randomMath } from "@/utils/com";
// import Category from "@/components/ranklist/Category";
interface IProps {
  softId?: number;
  dataText?: string; // 打点文案
  openType?: OpenType;
  href?: string;
  exec?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  ads?: IAds;
  comAds?: string[];
  type?: "button";
  foraword?: string;
  name?: string;
  position?: string;
  category?: string;
}

const Link = (props: IProps) => {
  const myRef = useRef<HTMLAnchorElement>(null);
  const {
    type,
    href = "",
    softId = 0,
    dataText = "",
    className = "",
    style = {},
    exec,
    ads,
    openType = OpenType.openDetailInHome,
    foraword = "",
    name,
    position,
    category,
    comAds,
  } = props;

  // const softUrl = `${SOFT}?id=${softId}`;
  // const [startTime, setStartTime] = useState(0);
  const softUrl = `${location.protocol}//${location.host}${SOFT}?id=${softId}`;
  // const ct = category && category.length > 0 ? `${ICategorys[category]}` : "";
  // const onMouseDown = (e: React.MouseEvent) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   setStartTime(Date.now());
  // };

  // const onMouseUp = (e: React.MouseEvent) => {
  //   if (Array.isArray(comAds) && comAds.length) {
  //     comAds.forEach(url => {
  //       const realUrl = replaceUrlTemplate(url, e, startTime, Date.now());
  //       comMonitor(realUrl);
  //     });
  //   }
  // };

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    const params = {
      cId: position, // 区域
      // c : "下载", //事件名称
      from: dataText, // 来源
      title: `${softId}-${name}`,
      f: RADAR_MONITOR.util.getHref(e.target),
    };
    sendClkLog(params, "click");

    if (ads && ads.clktk) {
      ads.clktk.forEach((url) => {
        monitor.sendLog(url);
      });
    }

    // banner 特殊处理
    if (position && position.indexOf("banner") > -1) {
      if (Array.isArray(comAds) && comAds.length) {
        const now = Date.now();
        const diff: number = randomMath(90, 145);
        comAds.forEach((url) => {
          const realUrl = replaceUrlTemplate(url, e, now - diff, now);
          comMonitor(realUrl);
        });
        window.localStorage.removeItem("position");
      }
    }

    const validOpenType =
      Object.values(OpenType).includes(openType) &&
      openType !== OpenType.download
        ? openType
        : OpenType.openDetailInHome;

    const openHandler = getOpenHandler(validOpenType);

    if (
      exec &&
      (validOpenType === OpenType.execCmdWithClient ||
        validOpenType === OpenType.openAppWithCmd)
    ) {
      return (openHandler as (input: string) => any)(exec);
    } else if (
      href &&
      (validOpenType === OpenType.openWithBrowser ||
        validOpenType === OpenType.openWithClient)
    ) {
      return (openHandler as (input: string) => any)(href);
    }

    if (IS_CLIENT) {
      (
        openHandler as (
          input?: number,
          t?: string,
          p?: string,
          s?: string,
        ) => any
      )(softId, "", position, category);
    } else {
      window.top!.location.href = `${getFullUrl(softUrl, position, category)}`;
    }
  };

  useEffect(() => {
    if (type === "button" || !ads) {
      // 按钮类型无需曝光打点
      return;
    }
    const options = {
      root: null,
      threshold: 0.5,
    };

    const observe = new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) {
        return;
      }

      ads.imptk.forEach((url) => {
        monitor.sendLog(url);
      });

      observer.disconnect();
    }, options);
    const target = myRef.current as HTMLElement;
    observe.observe(target);

    return () => {
      observe.disconnect();
    };
  }, [ads, type]);

  return (
    <a
      href="javascript: void(0)"
      ref={myRef}
      className={className}
      onClick={onClick}
      style={style}
      data-text={dataText}
      data-href={foraword}
      // onMouseDown={onMouseDown}
      // onMouseUp={onMouseUp}
    >
      {props.children}
    </a>
  );
};

export default Link;
